import { gql } from "@apollo/client";

const EDIT_PRELIMINARY_TABLE = gql`
  mutation editPreliminaryTable($tableID: String, $tableType: String!, $autoRecoValue: Boolean, $reason: String) {
    editPreliminaryTable(tableID: $tableID, tableType: $tableType, autoRecoValue: $autoRecoValue, reason: $reason) 
  }
`;

export default EDIT_PRELIMINARY_TABLE;
